import { frontendURL } from '../../../helper/URLHelper';

const BulkCampaignsView = () => import('./Index.vue');
const BulkCampaignShowView = () => import('./Show.vue');
const BulkCampaignsSettingsView = () => import('./Settings.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/bulk-campaigns'),
    name: 'bulk_campaigns_dashboard',
    meta: {
      permissions: ['administrator'],
    },
    component: BulkCampaignsView,
  },
  {
    path: frontendURL('accounts/:accountId/bulk-campaigns/settings'),
    name: 'bulk_campaigns_settings',
    meta: {
      permissions: ['administrator'],
    },
    component: BulkCampaignsSettingsView,
  },
  {
    path: frontendURL('accounts/:accountId/bulk-campaigns/:campaignId'),
    name: 'bulk_campaign_details',
    meta: {
      permissions: ['administrator'],
    },
    component: BulkCampaignShowView,
  },
];
